import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '../../../../../../components/Icon';
import Input from '../../../../../../components/Input';
import { StyledPeriodWrapper, StyledCheckboxWrapper, StyledRemoveIcon } from '../../styles/styles';
var SendWindowLine = function (_a) {
    var id = _a.id, window = _a.window, onChange = _a.onChange, onRemove = _a.onRemove;
    var possibleDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    var checkedDays = window.days === '' ? [] : window.days.split(',');
    var onChangeStart = function (event) {
        onChange(id, 'start', event.target.value);
    };
    var onChangeEnd = function (event) {
        onChange(id, 'end', event.target.value);
    };
    var toggleDay = function (day) {
        if (checkedDays.includes(day)) {
            checkedDays.splice(checkedDays.indexOf(day), 1);
        }
        else {
            checkedDays.push(day);
        }
        onChange(id, 'days', checkedDays.join(','));
    };
    var clockPattern = '^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$';
    return (_jsxs("tr", { children: [_jsx("td", { children: _jsxs(StyledPeriodWrapper, { children: [_jsx(Input, { type: "text", value: window.start, onChange: onChangeStart, placeholder: "00:00", maxLength: 5, pattern: clockPattern }), _jsx(Input, { type: "text", value: window.end, onChange: onChangeEnd, placeholder: "00:00", maxLength: 5, pattern: clockPattern })] }) }), possibleDays.map(function (day) {
                return _jsx("td", { children: _jsx(StyledCheckboxWrapper, { children: _jsx("input", { type: "checkbox", checked: checkedDays.includes(day), onChange: function () { return toggleDay(day); } }) }) }, day);
            }), _jsx("td", { children: _jsx(StyledRemoveIcon, { children: _jsx(Icon, { icon: "trash-alt", onClick: function () { return onRemove(id); } }) }) })] }, "container-".concat(id)));
};
export default SendWindowLine;
